import { render, staticRenderFns } from "./BasicClpReport.vue?vue&type=template&id=32f563d6&"
import script from "./BasicClpReport.vue?vue&type=script&lang=js&"
export * from "./BasicClpReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports